import React from 'react';
import { Box, BoxProps } from '@mui/material';

interface PageSectionProps extends BoxProps {
  children: React.ReactNode;
}

export default function PageSection({ children, sx, ...rest }: PageSectionProps) {
  return (
    <Box sx={{ px: '28px', pt: '20px', ...sx }} {...rest}>
      {children}
    </Box>
  );
}
